import { useTranslation } from "react-i18next";
import moment from "../moment";
import config from "../config";

export const SubText = ({ company }) => {
  const { t } = useTranslation();
  return `${t("container.general_words.company")}: ${company || "-"}`;
};

export const checkActiveAuditorPeriod = (startDate, endDate) => {
  const start = moment(startDate, config.defaultDateLongFormat);
  if (endDate) {
    const end = moment(endDate, config.defaultDateLongFormat);
    return moment().isBetween(start, end, "days", "[]");
  }
  return moment().isBetween(start, moment().format(config.defaultDateLongFormat), "days", "[]");
};
